import React from 'react';
import { NavLink } from 'react-router-dom';
import trans from 'translate';

import { FOOTER_LINKS, FOOTER_TERMS_POLICY } from '../../constants/general';
import SupportedTokensLink from '../Modals/HordSupportedTokens/SupportedTokensLink/SupportedTokensLink';
import './Footer.scss';

const Footer = () => (
  <div className="footer-wrapper">
    <div className="reserved-policy-wrapper">
      <div className="reserved">{trans('footer.reserved')}</div>
      {FOOTER_TERMS_POLICY.map(({ name, link, className }) => (
        <a
          key={name}
          className={['footer-external-link', className].join(' ')}
          target="_blank"
          rel="noopener noreferrer"
          href={link}
        >
          {trans(name)}
        </a>
      ))}
    </div>
    <div className="footer-links-wrapper">
      <SupportedTokensLink />
      {FOOTER_LINKS.map(({ name, link }) => (
        <a key={name} className="footer-link" target="_blank" rel="noopener noreferrer" href={link}>
          {name}
        </a>
      ))}
    </div>
  </div>
);

Footer.propTypes = {};

export default Footer;
